<!--
 * :Date: 2024-07-22 17:22:07
 * :Description: 筛选中 工厂——运行部——装置选择组件
 * :Author: zq.wei
 * :LastEditors: zq.wei
 * :LastEditTime: 2024-11-11 17:09:01
-->

<template>
  <div style="display: inline-block">
    <el-form-item label="工厂">
      <el-select v-model="value.factoryNo" filterable  clearable @change="changeOne">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="item in list1" :key="item.factoryNo" :label="item.factoryName" :value="item.factoryNo"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="运行部">
      <el-select v-model="value.workshopId" filterable clearable @change="changeTwo">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="item in list2" :key="item.workshopNo" :label="item.workshopName" :value="item.workshopNo"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="装置">
      <el-select v-model="value.unitId" filterable clearable @change="changeThree">
        <el-option label="全部" value=""></el-option>
        <el-option v-for="item in list3" :key="item.unitNo" :label="item.unitName" :value="item.unitNo"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    value: Object
  },
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: ""
      },
      list1: [],
      list2: [],
      list3: []
    };
  },
  created() {
    this.getList1();
  },
  methods: {
    // 传值进入且初始化
    async initQuery(){
      const {factoryNo, workshopId, unitId} = this.value;
      if(factoryNo){
        const params = { type: 2, code: factoryNo };
        const data = await this.getList(params);
        this.list2 = data;
      }

      if(workshopId){
        const params = { type: 3, code: workshopId };
        const data = await this.getList(params);
        this.list3 = data;
      }
    },
    async getList(params) {
      const res = await this.$axios.get("/tf/getAllFactoryBaseInfo", {
        params
      });
      // console.log("res", res.data.data);
      return res.data.data;
    },
    // 获取工厂列表
    async getList1() {
      const params = { type: 1 };
      const data = await this.getList(params);

      this.list1 = data;
    },
    // change  工厂
    async changeOne(factoryNo) {
      this.$emit('change');
      this.$emit('change1', factoryNo)
      this.value.factoryId = factoryNo
      this.value.workshopId = "";
      this.value.unitId = "";
      this.list2 = [];
      this.list3 = [];
      if (factoryNo != "") {
        // 查运行部数据
        const params = { type: 2, code: factoryNo };
        const data = await this.getList(params);
        this.list2 = data;
      }
    },
    async changeTwo(workshop) {
      this.$emit('change');
      this.$emit('change2', workshop)
      this.value.unitId = "";
      this.list3 = [];
      
      if (workshop != "") {
        // 查运行部数据
        const params = { type: 3, code: workshop };
        const data = await this.getList(params);
        this.list3 = data;
      }
    },
    changeThree(val){
      this.$emit('change');
      this.$emit('change3', val)
    },
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/selectUnit.vue